/**
 * [DSS] Herstellerangaben – Richtext Renderer
 *
 * Shopify stores richtext as portable-text JSON in metaobject
 * fields. Neither `mo.field` nor `mo.field.value` reliably
 * auto-renders to HTML in Liquid for metaobjects. The snippet
 * (`snippets/dss-herstellerangaben.liquid`) therefore emits the
 * raw JSON in a `<script type="application/json">` tag and this
 * module parses + walks it client-side.
 *
 * Expected markup emitted by the snippet:
 *   <script type="application/json"
 *           class="dss-herstellerangaben__data"
 *           data-anschrift>{ ...portable text JSON... }</script>
 *   <div class="dss-herstellerangaben__anschrift"></div>
 */
import { $$ } from '../utils/helpers.js';

function escapeHtml(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

function renderPortableText(dataEl) {
  try {
    const raw = (dataEl.textContent || '').trim();
    if (!raw) return;
    const tree = JSON.parse(raw);
    if (tree.type !== 'root' || !Array.isArray(tree.children)) return;

    const html = tree.children
      .filter((block) => block && block.type === 'paragraph')
      .map((block, i) => {
        const text = (block.children || [])
          .filter((node) => node && node.type === 'text' && node.value)
          .map((node) => node.value)
          .join('');
        if (!text) return '';
        // Preserve the merchant's line breaks: real `\n` chars
        // collapse to a single space in HTML, so convert them to
        // <br>. Escape first to avoid XSS, then re-introduce the
        // safe <br> tags.
        const safe = escapeHtml(text).replace(/\n/g, '<br>');
        return i === 0 ? safe : `<br>${safe}`;
      })
      .filter(Boolean)
      .join('');

    const target = dataEl.nextElementSibling;
    if (target && target.classList.contains('dss-herstellerangaben__anschrift')) {
      target.innerHTML = html;
    }
  } catch (e) {
    console.error('[DSS Herstellerangaben] Failed to render richtext:', e);
  }
}

export function initHerstellerangaben() {
  const els = $$('.dss-herstellerangaben__data');
  if (!els.length) return;
  els.forEach(renderPortableText);
}
